export const EMPTY_SITE_DATA = {
  city: '',
  country: '',
  netSuiteCustomerId: '',
  nsCustomerId: '',
  region: '',
  siteName: '',
}

export const EDITABLE_FIELDS = [
  'city',
  'country',
  'netSuiteCustomerId',
  'nsCustomerId',
  'region',
  'siteName',
]
